export default "__VITE_ASSET__ff46db61__"